<template>
    <div style="margin-bottom: 140px;">
        <div style="margin-bottom: 14px;text-align: left">
            <div class="page-header">
                <div class="search-box">
                    <input class="search-box__input" type="text" maxlength="20" v-model="searchPizza" placeholder="Знайди свою найкращу піцу" @keyup.enter="search()">
                    <div class="search-box__control">
                        <button type="button" class="search-box__clear" aria-label="Очистити пошук" @click="clearSearch()" v-if="searchPizza.length"></button>
                        <button type="button" class="search-box__btn" @click="search()">Пошук</button>
                    </div>
                </div>
            </div>
            <PizzaFilters v-if="$v2 && loaded" :products="products" v-model="pizzaKind"/>
        </div>
        <div v-if="!loaded">
            <img src="@/assets/loading.svg" style="width: 34px;">
        </div>

        <router-view/>
        <div class="products-pizza-container" v-if="loaded" v-show="showPizza">
            <div v-for="product in visibleProducts" :key="product.id">
                <Product :product="product"/>
            </div>
        </div>
    </div>
</template>

<script>
import Product from '@/components/Product.vue'
import PizzaFilters from '@/components/PizzaFilters.vue'
import { pizzaIs } from '@/pizzaKinds'
import axios from "axios";
import Vue from "vue";

export default {
    name: 'home',
    components: {
        Product,
        PizzaFilters
    },
    data() {
        return {
            searchPizza: '',
            products: [],
            pizzaKind: null,
            loaded: false,
            showPizza: false,
        }
    },

    computed: {
        visibleProducts() {
            return this.pizzaKind ? this.products.filter(product => pizzaIs(this.pizzaKind, product)) : this.products;
        }
    },

    mounted() {
        document.querySelector('body').style.overflow = '';


        this.$store.dispatch('getProducts').then(products => {
            this.products = products.filter((product) => product.category_id == 1);
            this.loaded = true;

            setTimeout(() => {
                this.showPizza = true;
            }, 500);
        });
    },

    methods: {
        clearSearch() {
            this.searchPizza = '';
            this.$store.dispatch('getProducts').then(products => {
                this.products = products.filter((product) => product.category_id == 1);
            });
        },

        search() {
            let search_url = `${Vue.prototype.SERVER_URL}/api/${JSON.parse(localStorage.getItem('locationCityId'))}/products`;

            if(this.searchPizza) {
                // «/», «?» чи «#» у пошуку інакше ламають адресу запиту
                search_url += '/search/' + encodeURIComponent(this.searchPizza);
            }
            search_url += '?category_id=1';

            this.loaded = false;
            this.showPizza = false;

            if(this.searchPizza) {
                axios.get(search_url).then(response => {
                    this.products = response.data.products;
                }).catch(e => console.log(e));
            }
            else {
                // Порожній пошук — знову всі піци, як після «×». Тут стояв products.filter(...) поза then:
                // products не оголошена, ReferenceError обривав пошук і спінер крутився без кінця
                this.$store.dispatch('getProducts').then(products => {
                    this.products = products.filter((product) => product.category_id == 1);
                });
            }
            this.loaded = true;
            this.showPizza = true;
        },
    }
}
</script>

<style>
.products-pizza-container {
    display: flex;
    flex-flow: wrap;
}

.page-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.page-title {
    font-weight: bold;
    font-size: 2rem;
    margin: 0 14px;
}

.search-box {
    display: flex;
    align-items: center;

    position: relative;

    min-width: 356px;
    max-width: 49%;
    width: 100%;
}

.search-box__input {
    width: 100%;
    min-height: 40px;
    padding: .375rem .75rem;
    border: 1px solid #5C5C5C;
    border-radius: 6px;
}
.search-box__input:focus {
    outline: none;
}

.search-box__control {
    position: absolute;
    top: 0;
    bottom: 0;
    right: -2px;

    display: flex;
    align-items: center;
}

.search-box__clear {
    position: relative;
    min-height: 40px;
    padding: .375rem .75rem;
    border: 0;
    background: none;

    color: #fb3431;
    cursor: pointer;
}

.search-box__clear:before, .search-box__clear:after {
    content: '';
    display: block;

    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    width: 14px;
    height: 2px;
    background: #fb3431;
}

.search-box__clear:after {
    transform: translate(-50%, -50%) rotate(-45deg);
}

.search-box__clear:before {
    transform: translate(-50%, -50%) rotate(45deg);
}

.search-box__btn {
    min-height: 40px;

    padding: 9px 34px;
    border: 1px solid #AB2321;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;

    line-height: 100%;
    font-size: 1.25rem;
    color: #fff;
    font-weight: 500;

    background-color: #AB2321;
    cursor: pointer;
}

@media only screen and (max-width: 1024px) {
    .products-pizza-container {
        flex-direction: column;
    }

    .page-title {
        margin-left: 0;
    }

    .search-box {
        min-width: 100%;
    }
}

</style>